/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_nav_stopwatch_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Count up with laps`)
};

const es_timer_nav_stopwatch_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta hacia adelante con vueltas`)
};

const de_timer_nav_stopwatch_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Runden hochzählen`)
};

const nl_timer_nav_stopwatch_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tel op met rondetijden`)
};

const fr_timer_nav_stopwatch_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comptez le temps écoulé avec des tours`)
};

const it_timer_nav_stopwatch_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta in avanti con i giri`)
};

const pt_br2_timer_nav_stopwatch_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conte o tempo com voltas`)
};

const pt_timer_nav_stopwatch_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conte de forma crescente com voltas`)
};

const ja_timer_nav_stopwatch_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラップ計測付きでカウントアップ`)
};

const zh_timer_nav_stopwatch_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正计时，支持计圈`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_nav_stopwatch_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_nav_stopwatch_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_nav_stopwatch_desc", locale)
	if (locale === "en") return en_timer_nav_stopwatch_desc(inputs)
	if (locale === "es") return es_timer_nav_stopwatch_desc(inputs)
	if (locale === "de") return de_timer_nav_stopwatch_desc(inputs)
	if (locale === "nl") return nl_timer_nav_stopwatch_desc(inputs)
	if (locale === "fr") return fr_timer_nav_stopwatch_desc(inputs)
	if (locale === "it") return it_timer_nav_stopwatch_desc(inputs)
	if (locale === "pt-BR") return pt_br2_timer_nav_stopwatch_desc(inputs)
	if (locale === "pt") return pt_timer_nav_stopwatch_desc(inputs)
	if (locale === "ja") return ja_timer_nav_stopwatch_desc(inputs)
	return zh_timer_nav_stopwatch_desc(inputs)
};